import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {PHONE_DIAL_CODE} from '@app/utils/constants';
import {
  sendInviteRequest,
  sendInviteSuccess,
  sendInviteError,
  fetchInvitesRequest,
  fetchInvitesSuccess,
  fetchInvitesError,
  fetchCorpReportsRequest,
  fetchCorpReportsSuccess,
  fetchCorpReportsError,
  updateReportStatusRequest,
  updateReportStatusSuccess,
  updateReportStatusError,
  fetchReportCommentsRequest,
  fetchReportCommentsSuccess,
  fetchReportCommentsError,
  fetchReportsAnalyticsDataRequest,
  fetchReportsAnalyticsDataSuccess,
  fetchReportsAnalyticsDataError,
  fetchRecentlyAddedReportsRequest,
  fetchRecentlyAddedReportsSuccess,
  fetchRecentlyAddedReportsError,
} from './index';
import {
  sendInvite,
  sendInviteLink,
  fetchInvites,
  fetchCorpReports,
  updateReportStatus,
  fetchReportComments,
  fetchReportsAnalyticsData,
  fetchRecentlyAddedReports,
} from './api';

export const sagaActions = {
  SEND_VALIDATOR_INVITE: 'SEND_VALIDATOR_INVITE',
  FETCH_VALIDATOR_INVITES: 'FETCH_VALIDATOR_INVITES',
  FETCH_CORPORATE_REPORTS: 'FETCH_CORPORATE_REPORTS',
  UPDATE_REPORT_STATUS: 'UPDATE_REPORT_STATUS',
  FETCH_REPORT_COMMENTS: 'FETCH_REPORT_COMMENTS',
  FETCH_VALIDATOR_REPORTS_ANALYTICS: 'FETCH_VALIDATOR_REPORTS_ANALYTICS',
  FETCH_RECENTLY_ADDED_REPORTS: 'FETCH_RECENTLY_ADDED_REPORTS',
};

function* sendInviteSaga({payload}) {
  const {values} = payload;
  try {
    yield put(sendInviteRequest());
    const result = yield call(sendInvite, {
      ...values,
      validatorPhone: `${PHONE_DIAL_CODE}${values.validatorPhone}`,
    });
    if (!result.error) {
      toast.success(result.message);
      yield put(sendInviteSuccess(true));
      yield call(sendInviteLink, {
        ...values,
        link: `http://20.101.158.40/register/${result.link}`,
      });
    } else if (result.error) {
      toast.error(result.error);
      yield put(sendInviteError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(sendInviteError(message));
    } else {
      toast.error(e.error);
      yield put(sendInviteError(e.error));
    }
  }
}

function* fetchInvitesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchInvitesRequest());
    const result = yield call(fetchInvites, values);
    if (!result.error) {
      yield put(
        fetchInvitesSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchInvitesSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchInvitesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchInvitesError(e.error));
    }
  }
}

function* fetchCorpReportsSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchCorpReportsRequest());
    const result = yield call(fetchCorpReports, values);
    if (!result.error) {
      yield put(
        fetchCorpReportsSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      // toast.error(result.error);
      yield put(
        fetchCorpReportsSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      // toast.error(message);
      yield put(fetchCorpReportsError(message));
    } else {
      // toast.error(e.error);
      yield put(fetchCorpReportsError(e.error));
    }
  }
}

function* updateReportStatusSaga({payload}) {
  const {values, reportId, history} = payload;
  try {
    yield put(updateReportStatusRequest());
    const result = yield call(updateReportStatus, reportId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateReportStatusSuccess(true));
      history.push('/validators/reports');
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateReportStatusError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateReportStatusError(message));
    } else {
      toast.error(e.error);
      yield put(updateReportStatusError(e.error));
    }
  }
}

function* fetchReportCommentsSaga({payload}) {
  const {values, reportId} = payload;
  try {
    yield put(fetchReportCommentsRequest());
    const result = yield call(fetchReportComments, reportId, values);
    if (!result.error) {
      yield put(
        fetchReportCommentsSuccess({
          reportId,
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      // toast.error(result.error);
      yield put(
        fetchReportCommentsSuccess({
          reportId: 0,
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      // toast.error(message);
      yield put(fetchReportCommentsError(message));
    } else {
      // toast.error(e.error);
      yield put(fetchReportCommentsError(e.error));
    }
  }
}

function* fetchReportsAnalyticsDataSaga({payload}) {
  const {values, reportId} = payload;
  try {
    yield put(fetchReportsAnalyticsDataRequest());
    const result = yield call(fetchReportsAnalyticsData, reportId, values);

    if (!result.error) {
      yield put(fetchReportsAnalyticsDataSuccess(result.data));
    } else if (result.error) {
      // toast.error(result.error);
      yield put(fetchReportsAnalyticsDataSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      // toast.error(message);
      yield put(fetchReportsAnalyticsDataError(message));
    } else {
      // toast.error(e.error);
      yield put(fetchReportsAnalyticsDataError(e.error));
    }
  }
}

function* fetchRecentlyAddedReportsSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchRecentlyAddedReportsRequest());
    const result = yield call(fetchRecentlyAddedReports, values);
    if (!result.error) {
      yield put(
        fetchRecentlyAddedReportsSuccess({
          data: result.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      // toast.error(result.error);
      yield put(
        fetchRecentlyAddedReportsSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      // toast.error(message);
      yield put(fetchRecentlyAddedReportsError(message));
    } else {
      // toast.error(e.error);
      yield put(fetchRecentlyAddedReportsError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.SEND_VALIDATOR_INVITE, sendInviteSaga);
  yield takeLatest(sagaActions.FETCH_VALIDATOR_INVITES, fetchInvitesSaga);
  yield takeLatest(sagaActions.FETCH_CORPORATE_REPORTS, fetchCorpReportsSaga);
  yield takeLatest(sagaActions.UPDATE_REPORT_STATUS, updateReportStatusSaga);
  yield takeLatest(sagaActions.FETCH_REPORT_COMMENTS, fetchReportCommentsSaga);
  yield takeLatest(
    sagaActions.FETCH_VALIDATOR_REPORTS_ANALYTICS,
    fetchReportsAnalyticsDataSaga
  );

  yield takeLatest(
    sagaActions.FETCH_RECENTLY_ADDED_REPORTS,
    fetchRecentlyAddedReportsSaga
  );
}

export default rootSagas;
